
import { defineComponent, PropType, ref } from 'vue';
import { useRouter } from 'vue-router';
import { HoundModel } from '../../../common';
import { ChevronRight, Plus as PlusIcon } from '@vicons/fa';
import StaminaRefillModal from '../components/StaminaRefillModal.vue';
import { staminaCap } from '../data/global';
import breakpoints from '../utils/breakpoints';

export default defineComponent({
  name: 'Hounds',
  emits: ['refillStamina'],
  props: {
    hound: {
      type: Object as PropType<HoundModel>,
      default: {},
      required: true
    }
  },
  components: {
    ChevronRight,
    PlusIcon,
    StaminaRefillModal
  },
  setup (props) {
    const router = useRouter();
    const openHound = (id: string) => {
      router.push({
        name: 'Hound',
        params: {
          id: id
        }
      });
    };
    const hound = props.hound as HoundModel;
    const showStaminaModal = ref(false);

    const staminaPercentage = Math.round((hound.stamina / hound.staminaCap) * 100);

    return {
      openHound,
      hound,
      showStaminaModal,
      staminaPercentage,
      breakpoints
    };
  }
});
